export function headerSearch() {
    const header = document.querySelector(".header");
    const headerSearch = header.querySelector(".header-search");

    header.addEventListener("click", function (e) {
        if (window.innerWidth >= 1200) {
            if (headerSearch.contains(e.target)) {
                header.classList.add("search-active");
            } else {
                header.classList.remove("search-active");
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSearch.js